<ng-container *ngIf="appId$ | async as appId">
    <lgv-form-navigator
    [objectIdParam]="appId"
    [level1Param]="level1$ | async"
    [level2Param]="level2$ | async"
    [formType]= "formType"
    [defaultDataModel]="defaultModel"
></lgv-form-navigator>
</ng-container>
